import { useSelector } from 'react-redux';
import { selectUser } from '@/store/bootstrap/selectors';

function capitalizeFirstLetter(string) {
  if (!string) return;
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const useVariables = () => {
  const currUser = useSelector(selectUser);
  const orgName =
    currUser?.account?.display_name || window?.location?.host.split('.')[0];

  return {
    candidate: {
      email: 'jane.cooper@janecoopertest.com',
      first_name: 'Jane',
      last_name: 'Cooper',
      full_name: 'Jane Cooper',
      company_name: 'Jane Cooper Technologies',
      phone_number: '(650) 123-7890',
      position: 'Chief Executive Officer',
      prev_step_day: 'last time',
      period_of_day: 'night',
      profile_url: window?.location?.host + '/candidates/7',
    },
    org: {
      name: capitalizeFirstLetter(orgName),
    },
    sender: {
      first_name: currUser?.first_name,
      last_name: currUser?.last_name,
      full_name: `${currUser?.first_name} ${currUser?.last_name || ''}`,
      email: currUser?.email,
      time_zone: 'UTC',
      email_signature: `${currUser?.first_name} ${currUser?.last_name || ''}`,
      title: 'recruiter',
    },
    job: {
      primary_recruiter_first_name: 'John',
      primary_recruiter_last_name: 'Adams',
      primary_recruiter_full_name: 'John Adams',
      primary_recruiter_title: 'Senior Recruiter',
      primary_recruiter_email: 'john.adams@examplerecruiter.com',
      recruiters_first_names: 'John, Jill, Jasmine',
      recruiters_last_names: 'Adams, Williams, Stevens',
      recruiters_full_names: 'John Adams, Jill Williams, Jasmine Stevens',
      recruiters_emails:
        'john.adams@examplerecruiter.com, jill.williams@examplerecruiter.com, jasmine.stevens@examplerecruiter.com',
      coordinators_first_names: 'Angela, Tim',
      coordinators_last_names: 'Thomas, Haskins',
      coordinators_full_names: 'Angela Thomas, Tim Haskins',
      coordinators_emails:
        'angela.thomas@examplecoordinator.com, tim.haskins@examplecoordinator.com',
      primary_hiring_manager_first_name: 'Becky',
      primary_hiring_manager_last_name: 'Allen',
      primary_hiring_manager_full_name: 'Becky Allen',
      primary_hiring_manager_title: 'Senior Accounts Manager',
      primary_hiring_manager_email: 'becky.allen@examplehm.com',
      hiring_managers_first_names: 'Becky, Rick',
      hiring_managers_last_names: 'Allen, Young',
      hiring_managers_full_names: 'Becky Allen, Rick Young',
      hiring_managers_emails:
        'becky.allen@examplehm.com, rick.young@examplehm.com',
      title: 'Account Executive',
      office_name: 'Headquarters',
      department: 'Sales',
      all_office_names: 'Headquarters, New York office, SF office',
      location: 'Chicago, Illinois, USA',
      all_locations:
        'Chicago, Illinois, USA, Brooklyn, New York, USA, San Jose, California, USA',
      sourcers_first_names: 'Oscar, Wilson',
      sourcers_last_names: 'Fernandes, Richards',
      sourcers_full_names: 'Oscar Fernandes, Wilson Richards',
      sourcers_emails:
        'oscar.fernandes@examplesourcer.com, wilson.richards@examplesourcer.com',
      post_link: `careers.kula.ai/acme/123`,
      current_stage: 'Application Review',
    },
    interview: {
      interviewer_first_name: 'Cassandra',
      interviewer_last_name: 'Roberts',
      interviewer_full_name: 'Cassandra Roberts',
      interviewer_email: 'cassandra.roberts@exampleinterviewer.com',
      interviewer_title: 'Junior Accounts Manager',
      all_interviewers_first_names: 'Cassandra, Nigel',
      all_interviewers_last_names: 'Roberts, Sheldon',
      all_interviewers_full_names: 'Cassandra Roberts, Nigel Sheldon',
      all_interviewers_emails:
        'cassandra.roberts@exampleinterviewer.com, nigel.sheldon@exampleinterviewer.com',
      all_interviewers_titles: 'Junior Accounts Manager, Account Executive',
      name: 'Round 1: Team meet & greet',
      link: 'https://round1.kula.ai',
      time: '12/05/2024 14:30:00',
      duration: '60 minutes',
      days_since_interview_ended: 'less than a day ago',
      'schedule.link': `https://bookyourinterview.${orgName}.com`,
      onsite_location: '123 Main St, Anytown, CA 12345',
      self_schedule_link: `https://schedule.${orgName}.com`,
      availability_link: `https://availability.${orgName}.com`,
    },
    referral: {
      first_name: 'Nigel',
      last_name: 'Sheldon',
      full_name: 'Nigel Sheldon',
      title: 'Account Executive',
      email: 'nigel.sheldon@examplereferrer.com',
      job_apply_link: `https://careers.${orgName}.com/referredbynigel`,
    },
    offer: {
      job_title: 'Senior Software Engineer',
      salary: '$120,000',
      pay_type: 'Annual',
      start_date: '2024-02-15',
      offer_date: '2024-01-15',
      additional_bonus: '$10,000',
      expiration_date: '2024-01-29',
      candidate_name: 'Jane Cooper',
      candidate_email: 'jane.cooper@janecoopertest.com',
      candidate_phone: '(650) 123-7890',
      candidate_address: '123 Main St, San Francisco, CA 94105',
      reporting_manager: 'Sarah Johnson',
      department: 'Engineering',
      office: 'San Francisco HQ',
      equity_type: 'Stock Options',
      equity_amount: '1000',
      equity_strike_price: '$25.00',
      equity_cliff: '1 year',
      equity_post_cliff_vesting_cycle: 'Monthly',
      equity_vesting_period: '4 years',
      req_id: 'REQ-2024-001',
      office_city: 'San Francisco',
      office_state: 'California',
      office_country: 'United States',
    },
    survey: {
      name: 'Candidate experience survey',
      link: window?.location?.host + '/surveys/3245',
    },
    user: {
      first_name: 'Michael',
      last_name: 'Rodriguez',
      full_name: 'Michael Rodriguez',
      email: 'michael@hm.com',
      time_zone: 'PST - Los Angeles',
      job_title: 'Senior Hiring Manager',
      reporting_manager_name: 'Sarah Chen',
      department: 'Sales',
      office: 'Sarah Chen',
    },
  };
};
